import { ClaimsService } from "@services/ClaimsService";

export const renderPanel = () => {
  return ClaimsService.hasUserReadClaim() || ClaimsService.hasFeedbackReadClaim();
};
